import React, { useEffect, useMemo, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import useFetchList from "../../utils/useFetchLIst";
import SelectInput from "../../custom/components/Select-Input/SelectInput";
import { Row, Col, Button, Form, Input } from "reactstrap";
import {
  formatDate,
  getRecords,
  saveRecords,
} from "../../services/api.service";
import { basicFormData, createPageData } from "./SparePartIssuesFile";
import { validate } from "../../custom/validations/Validate";
import { toast } from "react-toastify";
import TextInput from "../../custom/components/Text-Input/TextInput";
import CheckboxInput from "../../custom/components/CheckBox-Input/CheckboxInput";
import { LoaderCreatePage } from "../Loader/Loader";
import { loaderOverlay } from "../../Style/loaderOverly";
import NumberInput from "../../custom/components/Number-Input/NumberInput";

const SparePartIssuesCreate = () => {
  const { id } = useParams();

  const [formData, setFormData] = useState(basicFormData());
  const [selectedSparePartRequestId, setSelectedSparePartRequestId] =
    useState(null); // Add this line
  const [errors, setErrors] = useState({});
  const [sparePartRequestIdSelectOptions, setSparePartRequestIdSelectOptions] =
    useState([]);
  const [showSparePartIssues, setShowSparePartIssues] = useState(false);
  const navigate = useNavigate();
  const schema = localStorage.getItem("schema");

  const {
    payload,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formErrors, setFormErrors] = useState({});
  const [issue_qty, setIssue_qty] = useState(0)
  const [totalIssuedQty, setTotalIssuedQty] = useState(0)
  const action = id ? "Update" : "Create"
  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);
  useEffect(() => {
    if (selectedSparePartRequestId?.value) {
      handleFormSubmit();
    }
  }, [selectedSparePartRequestId]);

  const getEditData = async (id) => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        include: initialPayload?.include,
      };

      if (id) {
        payload.whereCondition = { id };
      }

      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data?.length > 0) {
        let data = responseData.data[0];
        setFormData({ inputData: data });
        setIssue_qty(data.issue_qty)
        setSelectedSparePartRequestId({
          value: data?.spare_part_request_id || null,
          label: data?.request?.spare_part_request_no || "-",
        });

        // 👉 Move API call to a separate effect
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    getSparePartRequestIdData();
  }, []);

  const getSparePartRequestIdData = async () => {
    setLoadingData(true)
    try {
      let payload = {
        modelName: "spare_part_requests",
        whereCondition: {
          is_active: true,
          status: "Pending"
        },
        schema: schema,
        orderBy: {
          field: "spare_part_request_no",
          order: "asc",
        },
      };

      const responseData = await getRecords(payload, "/getRecords");

      const newArray = responseData.data?.map((item) => ({
        value: item?.id,
        label: item?.spare_part_request_no,
      }));
      setSparePartRequestIdSelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Something went wrong please try again!")
    }
    setLoadingData(false)
  };

  const handleChange = (options) => {
    const selectedValue = options ? options.label : "";
    setErrors((prev) => ({
      ...prev,
      sparePartRequestNo: "",
    }));
    setSelectedSparePartRequestId(options);

    setFormData((prevState) => ({
      ...prevState,
      sparePartRequestNo: selectedValue,
    }));

    setShowSparePartIssues(false);
  };

  const handleFormSubmit = async (e) => {
    setLoadingData(true)
    if (e?.preventDefault) e.preventDefault();
    let newErrors = {};
    let valid = true;

    if (!selectedSparePartRequestId.value) {
      newErrors.sparePartRequestNo = "Spare Part Request No Cannot Be Blank.";
      valid = false;
    }

    if (!valid) {
      setErrors(newErrors);
      return;
    }

    try {

      let payload = {
        modelName: "spare_part_requests",
        schema: schema,

        whereCondition: {
          id: selectedSparePartRequestId.value,
        },

        include: [
          {
            model: "job_cards",
            as: "job_card",
          },
          {
            model: "material_masters",
            as: "spare",
          },
          {
            model: "user_masters",
            as: "requested_by_user",
          },
          {
            model: "spare_part_issues",
            as: "issues",
          },
        ],
      };

      const responseData = await getRecords(payload, "/getRecords");
      const record = responseData?.data?.[0];

      if (record) {
        const total_issued_qty = record.issues.reduce(
          (sum, issue) => sum + (Number(issue?.issue_qty) || 0),
          0
        );

        setTotalIssuedQty(total_issued_qty)
        setFormData((prev) => ({
          ...prev,
          inputData: {
            ...prev.inputData,
            job_card_no: record?.job_card?.job_card_no ?? null,
            total_issued_qty: total_issued_qty ?? null,
            spare_part: record?.spare?.name ?? null,
            quantity: record?.quantity ?? null,
            requested_at: formatDate(record?.requested_at) ?? null,
            status: record?.status ?? null,
            requested_by:
              `${record?.requested_by_user?.first_name}` +
              " " +
              `${record?.requested_by_user?.last_name}` ?? null,
          },
        }));
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    }

    setShowSparePartIssues(true);
    setLoadingData(false)
  };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "issue_qty") {
      const issuedQty = parseInt(value) || 0;
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          "total_issued_qty":
            type === "checkbox"
              ? checked === true
                ? 1
                : 0
              : name === "alt_mobile_number" && value === ""
                ? null
                : totalIssuedQty - issue_qty + issuedQty,
        },
      }));

      const totalQty = parseInt(formData?.inputData?.quantity, 10) || 0;


      if (((totalIssuedQty - issue_qty + issuedQty) > totalQty)) {
        setFormErrors((prevErrors) => {
          return {
            ...prevErrors,
            [name]: "Total issued quantity cannot be greater than Requested Quantity",
          };
        });
      } else {
        delete formErrors["issue_qty"]
      }
    } else {
      setFormErrors((prevErrors) => {
        const fieldError = validate(validationType, { [name]: value });
        return {
          ...prevErrors,
          [name]: fieldError[name] || null,
        };
      });
    }


    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]:
          type === "checkbox"
            ? checked === true
              ? 1
              : 0
            : name === "alt_mobile_number" && value === ""
              ? null
              : value,
      },
    }));
  };


  // Submit

  const handleSubmit = async (e) => {
    try {
      e?.preventDefault();
      setLoadingData(true);
      console.log(formData.inputData)
      const validationErrors = validate(validationType, formData.inputData);
      const userDetails = JSON.parse(localStorage.getItem("authUser"));

      if (JSON.stringify(formErrors) === "{}")
        setFormErrors(validationErrors);
      else
        return

      if (JSON.stringify(validationErrors) !== "{}" || formData.inputData.is_repairable === 1) {
        return;
      }

      const editPayload = {
        modelName: "spare_part_issues",
        schema: schema,
        id: id,
        inputData: {
          issue_qty: formData?.inputData?.issue_qty,
          issued_by: userDetails.id,
          issued_at: formData?.inputData?.issued_at,
        },
      };

      const createPayload = {
        "modelName": "spare_part_issues",
        "schema": schema,

        "inputData": {
          "spare_part_request_id": selectedSparePartRequestId.value,
          "issue_qty": formData.inputData?.issue_qty,
          "issued_by": userDetails?.id,
          "issued_at": formData?.inputData?.issued_at,
          "is_active": formData?.inputData?.is_active
        }
      }

      // console.log({createPayload, editPayload})
      // // return

      const responseData = id
        ? await saveRecords(editPayload, updateEndpoint)
        : await saveRecords(createPayload, createEndpoint);

      // Handle response
      if (responseData && responseData.code === 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate("/spare-part-issues-list");
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <>
      <div className="page-content">
        <Breadcrumbs title={` ${action} Spare Part Issues`} breadcrumbItems={[]} />
        <div className="card mb-3">
          <div className="container-fluid p-4 ">
            <form onSubmit={handleFormSubmit}>
              <div className="row mb-3 align-items-center">
                <div className="col-12 col-md-6">
                  <Col md="12" className="">
                    <SelectInput
                      label="Spare Part Request Id"
                      options={sparePartRequestIdSelectOptions}
                      value={selectedSparePartRequestId}
                      onSelect={handleChange}
                      placeholder="Select pare Part Request Id"
                      inputClassName="form-control"
                      labelClassName="form-label"
                      asterisk={true}
                      customError={errors.sparePartRequestNo}
                    />
                  </Col>
                </div>
                <div className="col-6 mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{
                      width: "80px",
                      fontSize: "13px",
                    }}
                  >
                    Go
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        {showSparePartIssues && (
          <div>
            <form onSubmit={handleSubmit} className="card p-3">
              <Row className="mt-2">
                <Col md="6" className="mt-3">
                  <TextInput
                    label="Job Card"
                    value={formData?.inputData?.job_card_no}
                    placeholder="Job Card"
                    inputClassName="form-control"
                    labelClassName="form-label"
                    disabled={true}
                  />
                </Col>
                <Col md="6" className="mt-3">
                  <TextInput
                    label="Spare Part"
                    value={formData?.inputData?.spare_part}
                    placeholder="Spare Part"
                    inputClassName="form-control"
                    labelClassName="form-label"
                    disabled={true}
                  />
                </Col>

                <Col md="6" className="mt-3">
                  <TextInput
                    label="Requested By"
                    value={formData?.inputData?.requested_by}
                    onChange={onInputChange}
                    placeholder="Issue Quantity"
                    inputClassName="form-control"
                    labelClassName="form-label"
                    disabled={true}
                  />
                </Col>

                <Col md="6" className="mt-3">
                  <TextInput
                    label="requested At"
                    value={formData?.inputData?.requested_at}
                    onChange={onInputChange}
                    placeholder="Issue Quantity"
                    inputClassName="form-control"
                    labelClassName="form-label"
                    disabled={true}
                  />
                </Col>

                <Col md="6" className="mt-3">
                  <TextInput
                    label="Status"
                    value={formData?.inputData?.status}
                    onChange={onInputChange}
                    placeholder="Status"
                    inputClassName="form-control"
                    labelClassName="form-label"
                    disabled={true}
                  />
                </Col>
                <Col md="6" className="mt-3">
                  <TextInput
                    label="Requested Quantity"
                    value={formData?.inputData?.quantity}
                    onChange={onInputChange}
                    placeholder="Issue Quantity"
                    inputClassName="form-control"
                    labelClassName="form-label"
                    disabled={true}
                  />
                </Col>
                <Col md="6" className="mt-3">
                  <TextInput
                    label="Total Issued Quantity"
                    value={formData?.inputData?.total_issued_qty}
                    placeholder="Total Issued Quantity"
                    inputClassName="form-control"
                    labelClassName="form-label"
                    disabled={true}
                  />
                </Col>
                <Col md="6" className="mt-3">
                  <NumberInput
                    label="Issue Quantity"
                    name="issue_qty"
                    value={formData?.inputData?.issue_qty}
                    onChange={onInputChange}
                    placeholder="Issue Quantity"
                    inputClassName="form-control"
                    labelClassName="form-label"
                    asterisk={true}
                    customError={formErrors?.issue_qty}
                  />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md="6" className="mt-3">
                  {" "}
                  <CheckboxInput
                    name="is_active"
                    label="Is Active"
                    value={formData?.inputData?.is_active}
                    checked={formData?.inputData?.is_active}
                    handleTextChange={onInputChange}
                    parentClassName="form-check"
                    checkBoxClassName="form-check-input"
                    labelClassName="form-check-label"
                  />
                </Col>
              </Row>

              <div className="mt-3 d-flex gap-3 flex-wrap">
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
                <button
                  onClick={() => navigate("/spare-part-issues-list")}
                  type="button"
                  className="btn btn-secondary"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
      {loadingData && (
        <div style={loaderOverlay}>
          <LoaderCreatePage />
        </div>
      )}
    </>
  );
};

export default SparePartIssuesCreate;
